import { lazy } from "react";
import ErrorBoundary from "@/hoc/ErrorBoundary/ErrorBoundary.jsx";

const PrivacyPolicy = lazy(() => import("./PrivacyPolicy"));

export const privacyPolicyRoute = {
  path: "privacyPolicy",
  element: <PrivacyPolicy />,
  errorElement: <ErrorBoundary />
};
